import { useCallback, useState } from 'react';
export const useActiveState = ({ onPointerUp, onPointerDown, }) => {
    const [active, setActive] = useState(false);
    const handlePointerUp = useCallback((event) => {
        setActive(false);
        if (onPointerUp) {
            onPointerUp(event);
        }
    }, [onPointerUp]);
    const handlePointerDown = useCallback((event) => {
        setActive(true);
        if (onPointerDown) {
            onPointerDown(event);
        }
    }, [onPointerDown]);
    return {
        active,
        onPointerUp: handlePointerUp,
        onPointerDown: handlePointerDown,
    };
};
//# sourceMappingURL=use-active-state.js.map